export default __webpack_public_path__ + "f09cf730670a6c6a08400e675dab5473.glb";